import InputText from 'bloko/blocks/inputText';

import useTrls from 'hooks/translation/useTrls';

import ClickmeFormItem from 'components/ClickmeFormItem';

import { setPayerLegalName } from 'store/models/payerCreate';
import { useDispatch, useSelector } from 'store/utils';

const PayerLegalName = () => {
    const dispatch = useDispatch();
    const { payerLegalName, payerErrors } = useSelector((state) => state.payerCreate);
    const trl = useTrls();

    return (
        <ClickmeFormItem
            input={
                <InputText
                    value={payerLegalName}
                    onChange={(value) => dispatch(setPayerLegalName(value))}
                    placeholder={trl('InvoiceAndPayerForm.PayerCreate.PayerLegalName.placeholder')}
                    invalid={Boolean(payerErrors.title)}
                    data-qa="title"
                />
            }
            legend={trl('InvoiceAndPayerForm.PayerCreate.PayerLegalName.legend')}
            isRequired
            error={payerErrors.title}
        />
    );
};

export default PayerLegalName;
